module.exports = __webpack_public_path__ + "img/logo.8954c259.png";